export var PQL_AVC_KEY;
(function (PQL_AVC_KEY) {
    PQL_AVC_KEY["ACV_THIS_YEAR"] = "acv_this_year";
    PQL_AVC_KEY["ACV_LAST_YEAR"] = "acv_last_year";
})(PQL_AVC_KEY || (PQL_AVC_KEY = {}));
export var PQL_FREQUENCY;
(function (PQL_FREQUENCY) {
    PQL_FREQUENCY["DAILY"] = "Daily";
    PQL_FREQUENCY["WEEKLY"] = "Weekly";
    PQL_FREQUENCY["MONTHLY"] = "Monthly";
})(PQL_FREQUENCY || (PQL_FREQUENCY = {}));
export var SEND_MODE;
(function (SEND_MODE) {
    SEND_MODE["EMAIL"] = "Email";
    SEND_MODE["DINGTALK"] = "DingTalk";
    SEND_MODE["API"] = "API";
    SEND_MODE["TAG"] = "Tag";
})(SEND_MODE || (SEND_MODE = {}));
export var PQL_GROUPBY;
(function (PQL_GROUPBY) {
    PQL_GROUPBY["ACCOUNT"] = "account";
    PQL_GROUPBY["COMPANY"] = "company";
})(PQL_GROUPBY || (PQL_GROUPBY = {}));
export var PQL_VIEWTYPE;
(function (PQL_VIEWTYPE) {
    PQL_VIEWTYPE["API"] = "API";
    PQL_VIEWTYPE["DINGTALK"] = "DingTalk";
    PQL_VIEWTYPE["TAG"] = "Tag";
    PQL_VIEWTYPE["EMAIL"] = "Email";
})(PQL_VIEWTYPE || (PQL_VIEWTYPE = {}));
export var PQL_LOGIC;
(function (PQL_LOGIC) {
    PQL_LOGIC["AND"] = "AND";
    PQL_LOGIC["OR"] = "OR";
    PQL_LOGIC["NOT"] = "NOT";
})(PQL_LOGIC || (PQL_LOGIC = {}));
export var PQL_OPERATION;
(function (PQL_OPERATION) {
    PQL_OPERATION["EQUAL"] = "=";
    PQL_OPERATION["GREATER_THAN"] = ">";
    PQL_OPERATION["LESS_THAN"] = "<";
    PQL_OPERATION["GREATER_THAN_OR_EQUAL"] = ">=";
    PQL_OPERATION["LESS_THAN_OR_EQUAL"] = "<=";
    PQL_OPERATION["NOT_EQUAL"] = "!=";
    PQL_OPERATION["IN"] = "in";
    PQL_OPERATION["NOT_IN"] = "not in";
})(PQL_OPERATION || (PQL_OPERATION = {}));
export var PQL_FIELDTYPE;
(function (PQL_FIELDTYPE) {
    PQL_FIELDTYPE["NUM"] = "number";
    PQL_FIELDTYPE["OPTION"] = "option";
    PQL_FIELDTYPE["TEXT"] = "text";
})(PQL_FIELDTYPE || (PQL_FIELDTYPE = {}));
export var PQL_STEP;
(function (PQL_STEP) {
    PQL_STEP[PQL_STEP["STEP_ONE"] = 1] = "STEP_ONE";
    PQL_STEP[PQL_STEP["STEP_TWO"] = 2] = "STEP_TWO";
})(PQL_STEP || (PQL_STEP = {}));
export var PQL_TAG_STATIUS;
(function (PQL_TAG_STATIUS) {
    PQL_TAG_STATIUS["RISK"] = "risk";
    PQL_TAG_STATIUS["OPPORTUNITY"] = "opportunity";
    PQL_TAG_STATIUS["OTHER"] = "other";
})(PQL_TAG_STATIUS || (PQL_TAG_STATIUS = {}));
export var RuleTimeEffectiveType;
(function (RuleTimeEffectiveType) {
    RuleTimeEffectiveType["T0"] = "T0";
    RuleTimeEffectiveType["T1"] = "T1";
})(RuleTimeEffectiveType || (RuleTimeEffectiveType = {}));
